export default {
    path: 'trouble_zg',
    name: 'trouble_zg',
    component: r => require.ensure([], () => r(require('./index.vue')), 'trouble_zg'),
    redirect: {name: 'trouble_zg_list'},
    children: [
        {
            path: 'trouble_zg_list',
            name: 'trouble_zg_list',
            component: r => require.ensure([], () => r(require('./list.vue')), 'trouble_zg_list'),
        }
    ]
}
